import React from 'react';
import { GridGenerator, HexGrid, Layout, Hexagon, Text } from 'react-hexgrid';
import { Grid, Box, Button } from '@material-ui/core';
import '@user-style/hexgrid.css';

export default class BrainHexMap extends React.Component {
    
    maxHex = 60
    constructor(props) {
        super(props);

        // 반지름 4 벌집은 61칸 — 중앙 셀은 BH 로고 자리로 비워서
        // 링 6+12+18+24 = 60칸이 60초 측정과 1:1 대응하게 한다.
        const hexas = GridGenerator.hexagon(4)
        this.centerIndex = hexas.findIndex((h) => 0 === h.q && 0 === h.r)

        const hex = []
        for (let i = 0 ; i < hexas.length; i++){
            if(i !== this.centerIndex) hex.push(i)
        }


        this.state = {
            measureCoord: new Array(hexas.length).fill({measureType:'', value:0}),
            hexas,
            ableHex: hex,
            timeCount: 0,
            rest: 0,
            attemption: 0,
            concentration: 0,
            restAvg: new Array(4).fill(0),
            attemAvg: new Array(4).fill(0),
            constAvg: new Array(4).fill(0),
            brainactiveAvg: new Array(4).fill(0),
            prescriptionID: props.prescriptionID,
            width: props.width ? props.width : 300,
            height: props.height ? props.height : 300
        }

    }

    //기기에서 측정된 데이터를 받을 경우
    addMeasureData = (currentStep, time, isHit, hitMv = '') => {            
        let coord = this.state.ableHex.shift()
        let measureType = 'rest'

        if(0 === currentStep) { measureType = 'rest'}
        if(1 === currentStep) { measureType = 'attemption'}
        if(2 === currentStep) { measureType = 'concentration'}
        if(3 === currentStep) { measureType = 'brainactive'}


        this.state.measureCoord[coord] = {
            measureType: isHit ? 'fill ' + measureType : measureType,
            value : isHit,
            hitMv: hitMv
        }

        this.setState({
            ableHex: this.state.ableHex,
            measureCoord: this.state.measureCoord,
            timeCount: time,
            rest: 0 === currentStep && isHit ? this.state.rest + 1 : this.state.rest ,
            attemption: 1 === currentStep && isHit ? this.state.attemption + 1 : this.state.attemption ,
            concentration: 2 === currentStep && isHit ? this.state.concentration + 1 : this.state.concentration,
            brainactive: 3 === currentStep && isHit ? this.state.brainactive + 1 : this.state.brainactive
        })

        return {
            coord,
            measureType
        }
    }

    /**
     * 이전 측정된 데이터를 화면에 표시합니다.
     * @param data
     * @param measureType
     * @param needUpdate
     */
    setHexMap(data, measureType , needUpdate = false) {
        if(!data) return;
        
        data.split(',').map((value, index) => {
            // 중앙(BH) 셀을 건너뛰어 데이터 인덱스를 셀 인덱스로 변환
            const coord = index >= this.centerIndex ? index + 1 : index
            this.state.measureCoord[coord] = {
                measureType: '1' === value ? 'fill ' + measureType : measureType
            }
        })

        if(needUpdate){
           this.needUpdate();
        }
    }


    /**
     * 화면을 업데이트 합니다.
     */
    needUpdate() {
        this.setState({
            ...this.state
        });
    }

    setAvr = (type, avr) =>{
        if('rest' === type){
            this.setState({
                restAvg: avr
            })
        } else if('attemption' === type){
            this.setState({
                attemAvg: avr
            })
        } else if('concentration' === type){
            this.setState({
                constAvg: avr
            })
        } else if('concentration' === type){
            this.setState({
                brainactiveAvg: avr
            })
        }
    }

    setAvgAll = (avg) =>{
        this.setState({
            restAvg: avg
        });

    }

    render() {
        return (
            <div >
                <Box width={this.state.width} 
                    position="absolute"
                    left="5%"
                    zIndex="tooltip"
                >
                </Box>
                <HexGrid width={this.state.width} height={this.state.height} viewBox="-50 -50 100 100">
                    <Layout size={ { x: 6, y: 6 } } origin={ { x: 0, y: 0 } } flat={ false } spacing={ 1.1 }>
                    { this.state.hexas.map((hex, i) => {
                        if(i === this.centerIndex){
                            return (
                                <Hexagon key={i} q={hex.q} r={hex.r} s={hex.s} className={'bh-center'}>
                                    {/* 중앙 태양 아이콘 (viewBox 24x24 → 셀 크기 맞춤) */}
                                    <g className={'bh-center-icon'} transform="translate(-4.5, -4.5) scale(0.375)">
                                        <path d="M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5001M17.6859 17.69L18.5 18.5001M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" style={{fill: 'none', stroke: '#FDD72C', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round'}}/>
                                    </g>
                                </Hexagon>
                            )
                        }

                        let className = ""
                        const val = this.state.measureCoord[i]

                        if(val && '' !== val.measureType){
                            className = val.measureType
                        }

                        return <Hexagon key={i} q={hex.q} r={hex.r} s={hex.s} className={className} />
                        })
                    }
                    </Layout>
                </HexGrid>
            </div>
        )
    }
}

export class HexDebug extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            restAvg : props.restAvg,
            attemAvg: props.attemAvg,
            constAvg: props.constAvg,
            brainactiveAvg: props.brainactiveAvg
        }
    }
    render() {
        return <Box>
            <Grid container>
                <Grid item xs={4}>
                    {/* 안정 : {this.state.rest}, { parseInt(this.state.rest / 60 * 100) }% */}
                    안정
                    {this.state.restAvg.map((avr, index) => {
                        return <div key={index+8}>{index + 8}hz : {avr}</div>
                    })}
                </Grid>
                <Grid item xs={4}>
                    주의력
                    {/* 집중력 : {this.state.attemption}, { parseInt(this.state.attemption / 60 * 100) }% */}
                    {this.state.attemAvg.map((avr, index) => {
                        return <div key={index+12}>{index + 12}hz : {avr}</div>
                    })}
                </Grid>
                <Grid item xs={4}>
                    집중력
                    {/* 주의력 : {this.state.concentration}, { parseInt(this.state.concentration / 60 * 100) }% */}
                    {this.state.constAvg.map((avr, index) => {
                        return <div key={index+16}>{index + 16}hz : {avr}</div>
                    })}
                </Grid>
                <Grid item xs={4}>
                    뇌활성
                    {/* 주의력 : {this.state.concentration}, { parseInt(this.state.concentration / 60 * 100) }% */}
                    {this.state.brainactiveAvg.map((avr, index) => {
                        return <div key={index+16}>{index + 20}hz : {avr}</div>
                    })}
                </Grid>
            </Grid>
            <br/>
            <Button variant="outlined" onClick={() => {
                window.open('/measureBalance/' + this.state.prescriptionID)
            }}>측정값 보기</Button>
        </Box>
    }
}